import { ContestType } from '@betterpool/api-types/contests-service';

import type {
  FullContest,
  FullContestPlayerTiers,
} from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import { Match } from '~/domains/common/components/Match/Match';

import MyEntriesPlayers from './MyEntriesPlayers/MyEntries';
import MyEntriesTeams from './MyEntriesTeams/MyEntries';

type MyEntriesProps = {
  contestId: string;
  fullContest: FullContest;
  myEntriesStatus?: string;
  openEntryNameEditModal: (entryInfo: { id: string; name: string }) => void;
};

function getTiersCount(contestData: FullContestPlayerTiers) {
  const { numberOfTiers = 0, numberPerTier = 0 } = contestData.tier_rules_settings ?? {};
  return numberOfTiers * numberPerTier;
}

function MyEntries({
  contestId,
  myEntriesStatus,
  fullContest,
  openEntryNameEditModal,
}: MyEntriesProps) {
  return (
    <Match<ContestType> value={fullContest?.contest_type}>
      <Match.On<ContestType>
        value={[
          ContestType.PLAYER_TIER,
          ContestType.PLAYER_CATEGORY,
          ContestType.PLAYER_ONE_AND_DONE,
        ]}
      >
        <MyEntriesPlayers
          contestId={contestId}
          tiersCount={getTiersCount(fullContest as FullContestPlayerTiers)}
          myEntriesStatus={myEntriesStatus}
          fullContest={fullContest}
          openEntryNameEditModal={openEntryNameEditModal}
        />
      </Match.On>

      <Match.On<ContestType> value={[ContestType.PLAYER_SURVIVOR]}>
        <MyEntriesPlayers
          contestId={contestId}
          myEntriesStatus={myEntriesStatus}
          fullContest={fullContest}
          openEntryNameEditModal={openEntryNameEditModal}
        />
      </Match.On>

      <Match.On<ContestType> value={[ContestType.TEAM_PICK_EM, ContestType.TEAM_SURVIVOR]}>
        <MyEntriesTeams
          myEntriesStatus={myEntriesStatus}
          fullContest={fullContest}
          openEntryNameEditModal={openEntryNameEditModal}
        />
      </Match.On>
    </Match>
  );
}

export default MyEntries;
